import type { INavigation } from '../INavigation';

export default [
  {
    id: 'electronics-digital-cameras',
    name: 'Digital Cameras',
    onlineSubCategoriesCount: 0
  },
  {
    id: 'electronics-televisions',
    name: 'Televisions',
    onlineSubCategoriesCount: 2,
    categories: [
      { id: 'electronics-televisions-flat-screen', name: 'Flat Screen' },
      {
        id: 'electronics-televisions-projection',
        name: 'Projection',
        onlineSubCategoriesCount: 0
      }
    ]
  }
] as Array<INavigation>;
